module.exports = __webpack_public_path__ + "img/ic_play.341d3c9c.svg";